import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_ESTIMACION_STOCK } from '../../../config/forms'
import SimulacionProyeccion from './SimulacionProyeccion'
import {
  actualizarSimulacionActiva,
  updateIsSimulacion,
  updateFechaCalendario,
  resetShowDestalleCuposADescargar,
  actualizarExportadorProyeccion,
  obtenerProyeccionExportador,
  obtenerCuposVigentes,
  obtenerEspacioDisponibleElevador,
  obtenerEspacioMaximoElevador
} from '../actions/listados'
import { obtenerParametroCumplimiento, obtenerParametroCamion } from '../actions'

function SimulacionInicializar (props) {
  const {
    actualizarSimulacionActiva,
    updateIsSimulacion,
    updateFechaCalendario,
    resetShowDestalleCuposADescargar,
    actualizarExportadorProyeccion,
    obtenerProyeccionExportador,
    obtenerCuposVigentes,
    obtenerParametroCumplimiento,
    obtenerParametroCamion,
    obtenerEspacioDisponibleElevador,
    obtenerEspacioMaximoElevador,
    change: formChange
  } = props

  useEffect(() => {
    obtenerParametroCamion()
    obtenerParametroCumplimiento()
    obtenerEspacioDisponibleElevador()
    obtenerEspacioMaximoElevador()
    obtenerProyeccionExportador()
    obtenerCuposVigentes()

    updateIsSimulacion(true)
    actualizarSimulacionActiva(true)
    updateFechaCalendario(null)
    resetShowDestalleCuposADescargar()
    actualizarExportadorProyeccion(null)
    formChange('exportadorProyeccion', '')

    return () => {
      updateIsSimulacion(false)
      actualizarSimulacionActiva(false)
    }
  }, [
    actualizarSimulacionActiva,
    updateIsSimulacion,
    updateFechaCalendario,
    resetShowDestalleCuposADescargar,
    actualizarExportadorProyeccion,
    obtenerProyeccionExportador,
    obtenerCuposVigentes,
    obtenerParametroCumplimiento,
    obtenerParametroCamion,
    obtenerEspacioDisponibleElevador,
    obtenerEspacioMaximoElevador,
    formChange
  ])

  return <SimulacionProyeccion />
}

const mapActionsToProps = {
  actualizarSimulacionActiva,
  updateIsSimulacion,
  updateFechaCalendario,
  resetShowDestalleCuposADescargar,
  actualizarExportadorProyeccion,
  obtenerProyeccionExportador,
  obtenerCuposVigentes,
  obtenerParametroCumplimiento,
  obtenerParametroCamion,
  obtenerEspacioDisponibleElevador,
  obtenerEspacioMaximoElevador
}

const withReduxForm = reduxForm({
  form: FORM_ESTIMACION_STOCK,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false
})(SimulacionInicializar)

const withRedux = connect(null, mapActionsToProps)
export default withRedux(withReduxForm)
